import { Typography } from 'antd';
import { TFilterItem } from 'components/rest/Filter/FilterRow';
import { IRestColumnProps } from 'components/rest/Table/TableColumn';
import ButtonPrintLabel from 'containers/Orders/components/ButtonPrintLabel';
import RestList from 'containers/rest/List';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { DynamicObjectType, FilterFromUrlResponseType } from 'types/commons';
import { formatDateTime } from 'utils/formattedString';
import useGetSearchKey from 'hooks/useSearchKeys';
import { DATA_FIELD_SEARCH } from './utils';
import { BATCH_STATUS } from 'constants/constants';
import { useTranslation } from 'react-i18next';

const renderBatchStatus = (d, rc: DynamicObjectType) => {
  const { t } = useTranslation();
  return (
    <span className={`${BATCH_STATUS[rc?.batchStatus]?.color}`}>
      {t(BATCH_STATUS[rc?.batchStatus]?.text)}
    </span>
  );
};

const columns: IRestColumnProps[] = [
  {
    name: 'batchId',
    title: 'Batch ID',
    isDefault: true,
    render: (d: string, record: DynamicObjectType) => (
      <Link to={`/order-management/${record?.id}/detail`}>
        <Typography.Paragraph
          ellipsis={{ rows: 1 }}
          style={{ width: 150, color: '#AB2328' }}
        >
          {formatDateTime(record?.createdAt, 'DDMMYYYY')}_{record?.id}
        </Typography.Paragraph>
      </Link>
    ),
    width: 200,
  },
  {
    name: 'createdAt',
    title: 'Created Time',
    render: (d) => (
      <p style={{ minWidth: 150 }}>{d ? formatDateTime(d) : ''}</p>
    ),
    width: 300,
    isDefault: true,
  },
  {
    name: 'orderQuantity',
    title: 'Order Quantity',
    render: (d, rc: DynamicObjectType) => <>{rc?.orderCount || 0}</>,
    isDefault: true,
  },
  {
    name: 'itemsCount',
    title: 'Number of items',
    render: (d, rc: DynamicObjectType) => <>{rc?.itemsCount || 0}</>,
    isDefault: true,
  },
  {
    name: 'batchStatus',
    title: 'Batch Status',
    render: (d, rc: DynamicObjectType) => renderBatchStatus(d, rc),
    isDefault: true,
  },
  {
    name: 'action',
    title: 'Action',
    render: (d, rc: DynamicObjectType) => {
      return (
        <ButtonPrintLabel isMarketPlace={rc?.isMarketPlace} batchId={rc?.id} />
      );
    },
    isDefault: true,
  },
  // {
  //   name: 'batchStatus',
  //   title: 'Batch Status',
  //   render: (d, rc: DynamicObjectType) => (
  //     <span className={`${BATCH_STATUS[rc?.batchStatus]?.color}`}>
  //       {t(BATCH_STATUS[rc?.batchStatus]?.text)}
  //     </span>
  //   ),
  //   isDefault: true,
  // },
];

const JOIN = ['orderBatch', 'chainStore', 'location', 'shop', 'orderItems'];

const BatchList = ({
  filtersInHeader,
}: {
  initialFilter?: DynamicObjectType;
  filtersInHeader?: TFilterItem[];
}) => {
  const { searchKeys } = useGetSearchKey(DATA_FIELD_SEARCH);

  const restInitialFilter: FilterFromUrlResponseType = useMemo(
    () => ({
      join: JOIN,
      orderBy: 'createdAt',
    }),
    [],
  );

  return (
    <RestList
      initialFilter={restInitialFilter}
      columns={columns}
      model="orderBatches"
      filters={filtersInHeader}
      // customActions={[<ImportOrders key="0" />]}
      searchKeys={searchKeys}
      dataFieldSearch={DATA_FIELD_SEARCH}
      hasOnlyFilter
      placeholderInputSearch="Search by Order ID, SO, SKU, Shipping Phone, Email, ..."
      rowSelectionActions={<></>}
      hasImport={false}
      hasExport={false}
      hasCustomLayout
      extraActionFilters={<ButtonPrintLabel />}
      // defaultOptions={{
      //   customApiResource: `order-batches/custom-views-packing`,
      // }}
    />
  );
};

export default BatchList;
